import { InternalThemeConfig } from "../../config";

import { darken } from "@mui/material";

const contained = (config: InternalThemeConfig) => {
	const { palette } = config;

	return {
		containedPrimary: {
			color: palette.white,
			background: `${palette.primary}`,
			boxShadow: "none",

			"&:hover": {
				background: `${darken(palette.primary, 0.1)}`,
				boxShadow: "none",
			},
			"&:active": {
				background: `${darken(palette.primary, 0.2)}`,
				backgroundColor: undefined,
				boxShadow: "none",
			},
			"@media (hover: none)": {
				"&:hover": {
					background: `${palette.primary}`,
				},
				"&:active": {
					background: `${palette.primary}`,
					boxShadow: "none",
				},
			},
			"&:disabled": {
				boxShadow: "none",
				background: "#FFB699",
			},
			"& .MuiLoadingButton-loadingIndicator": {
				color: palette.white,
			},
		},
		containedSecondary: {
			color: palette.black,
			background: `${palette.secondary}`,
			boxShadow: "none",

			"&:hover": {
				background: `${darken(palette.secondary, 0.1)}`,
				boxShadow: "none",
			},
			"&:active": {
				background: `${darken(palette.secondary, 0.2)}`,
				backgroundColor: undefined,
				boxShadow: "none",
			},
			"&:disabled": {
				boxShadow: "none",
				background: palette.grey40,
			},
		},
	};
};

export default contained;
